<template>
  <div class="relative pt-32 bg-white">
    <div class="absolute top-32 right-0 md:block lg:block hidden">
      <img
        src="./../../assets/images/bg-des/career-dots.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute bottom-32 left-0 md:block lg:block hidden">
      <img
        src="./../../assets/images/bg-des/CD-dots2.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-1/4 right-1/4 md:block lg:block hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="absolute top-1/2 left-20 md:block lg:block hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="flex gap-16 custjustifycenter lg:px-28 md:px-28 px-5">
      <div class="lg:w-3/5 md:w-3/5 justify-center items-center mob-hidden">
        <h2 class="fsize48 font-bold subtitle pl">Welcome to</h2>
        <span class="fsize48 font-bold text-primary">Caregiver Saathi</span>
        <p class="fsize20">
          A registered user gets access to curated content under Insights,
          Blogs, Podcasts, and many more.
        </p>
        <div class="pt-5">
          <div
            class="font-bold text-center fsize20 md-fsize25 fsize36-16px text-black md:px-0 lg:px-0 px-6"
          >
            Download App
          </div>
          <div
            class="flex justify-center md:pt-4 lg:pt-4 pt-2 md:pl-0 lg:pl-0 pl-4"
          >
            <a
              href="https://play.google.com/store/apps/details?id=com.ceraproject"
              alt="playstore"
              target="_blank"
              class="contents"
            >
              <img
                src="@/assets/images/appstore.svg"
                alt="Download"
                class="md:h-14 lg:h-5 h-auto mx-2 md:w-auto lg:w-40 w-1/3 md-w-130px"
              />
            </a>
            <a
              href="https://apps.apple.com/in/app/caregiver-saathi/id1640805488"
              alt="playstore"
              target="_blank"
              class="contents"
            >
              <img
                src="@/assets/images/istore.svg"
                alt="Download"
                class="md:h-14 lg:h-5 h-auto mx-2 md:w-auto lg:w-40 w-1/3 md-w-130px"
              />
            </a>
          </div>
        </div>
        <!-- src="@/assets/images/coach/OnlineLEARN.png" -->
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/banner-latino-indian-man-woman-couple-use-their-laptop-living-room-make-video-calls-copy-space-video.jpg"
          alt=""
          class="object-contain w-full h-360px"
        />
      </div>

      <div class="lg:w-2/5 md:w-2/5 w-full">
        <card class="shadow-lg">
          <div class="mx-auto">
            <p class="fsize25 text-center font-semibold text-black">
              Partner Sign In
            </p>
            <!-- <p class="subtitle tracking-wide fsize18 text-center">
              Don't have an account?
              <span
                class="ml-2 font-bold text-primary underline cursor-pointer"
                @click="register()"
                >Register Now</span
              >
            </p> -->
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <!-- <validation-provider :rules="''" name="Invalid" v-slot="{ errors }">
              <div
                class="invalid-feedback"
                style="display: block"
                v-if="errors[0]"
              >
                {{ errors[0] }}
              </div>
            </validation-provider> -->
                <div class="">
                  <div class="w-full">
                    <div class="">
                      <div class="pt-4">
                        <p class="input-title-black">Username</p>
                        <base-input
                          v-model="Username"
                          :rules="{ required: true }"
                          name="Username"
                          placeholder="Enter Email / Mobile Number"
                          class="mt-1 shadow-md"
                          @keyup="handleUsername(Username)"
                          @change="verifyUser(Username)"
                        ></base-input>
                      </div>
                      <div class="mt-4 relative">
                        <p class="input-title-black">Password</p>
                        <base-input
                          :rules="{ required: true, min: 6 }"
                          :type="passwordFieldType"
                          v-model="password"
                          name="Password"
                          placeholder="Enter Your Password"
                          class="mt-1 shadow-md"
                        >
                        </base-input>
                        <div
                          class="absolute flex top-10 right-0"
                          @click="switchVisibility"
                        >
                          <feather-icon
                            icon="EyeOffIcon"
                            svgClasses="w-4 h-4 mr-2 "
                            v-if="passwordFieldType === 'password'"
                          />
                          <feather-icon
                            v-else
                            icon="EyeIcon"
                            svgClasses="w-4 h-4 mr-2 "
                          />
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-wrap justify-between my-2">
                      <router-link
                        :to="{
                          name: 'forgot-password',
                          query: { change: 'true' },
                        }"
                        >Forgot Password?</router-link
                      >
                    </div>
                  </div>
                </div>

                <div class="mt-4 flex gap-3 justify-center">
                  <base-button
                    type="primary"
                    native-type="submit"
                    class="md:px-10 lg:px-10 w-52 px-6 md:py-2 lg:py-2 py-1 border-2 text-base font-bold mt-6 w-full"
                    >Login</base-button
                  >
                  <!-- <base-button
                    type="primary"
                    outline
                    class="outline md:px-10 lg:px-10 px-6 w-52 md:py-2 lg:py-2 py-1 text-base font-bold mt-6"
                    @click="register()"
                    >Register Now</base-button
                  > -->
                </div>
                <span class="flex justify-center mt-4 font-bold subtitle"
                  >or</span
                >
                <div class="lg:flex md:flex gap-4 justify-center">
                  <div class="lg:flex gap-4 mt-4 md:flex justify-center">
                    <div
                      class="flex items-center rounded-md border-primaryy"
                      @click="getAuthUrl"
                    >
                      <div
                        class="bg-white w-10 h-10 items-center justify-center rounded-full flex"
                      >
                        <img
                          src="@/assets/images/new/g-icon.png"
                          class="h-10 w-10 my-auto"
                          alt="Google"
                        />
                      </div>
                      <p
                        class="fsize12 font-semibold px-2 py-2 text-primary cursor-pointer"
                      >
                        Sign in with Google
                      </p>
                    </div>
                  </div>
                  <div class="lg:flex gap-4 mt-4 md:flex justify-center">
                    <a :href="`${url}linkedin/`">
                      <div
                        class="flex items-center rounded-md border-primaryy"
                        @click="signUpLinkedIn"
                      >
                        <div
                          class="bg-white w-10 h-10 items-center justify-center rounded-full flex"
                        >
                          <img
                            src="@/assets/images/new/l-icon.png"
                            class="h-10 w-10 my-auto"
                            alt="Google"
                          />
                        </div>
                        <p
                          class="fsize12 font-semibold px-2 py-2 text-primary cursor-pointer"
                        >
                          Sign in with LinkedIn
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <!-- <div class="flex justify-center mb-0">
                  <div class="flex items-center m-2 rounded-md border-primaryy">
                    <div
                      class="bg-white w-10 h-10 items-center justify-center rounded-full flex"
                    >
                      <img
                        src="@/assets/images/new/w-icon.png"
                        class="h-10 w-10 my-auto"
                        alt="Google"
                      />
                    </div>
                    <p
                      class="fsize14 font-semibold px-2 py-2 text-primary cursor-pointer"
                    >
                      Continue with WhatsApp
                    </p>
                  </div>
                </div> -->
                <div class="flex justify-center">
                  <div id="otpless" class="w-240px butt"></div>
                </div>
                <!-- <div class="flex justify-center">
                  <a :href="`${url}linkedin/`">
                    <div class="flex justify-center mb-4" @click="signUpLinkedIn">
                      <img
                        src="@/assets/images/signin-linkedin-button.png"
                        class="width15"
                        alt="LinkedIn"
                      />
                    </div>
                  </a>
                </div> -->
              </b-form>
            </validation-observer>
          </div>
        </card>
      </div>
    </div>

    <!-- <DownloadApp /> -->
  </div>
</template>
<script>
// import DownloadApp from "@/views/home/components/DownloadApp.vue";
export default {
  components: {
    // DownloadApp,
  },

  data() {
    return {
      Username: "",
      mobile: "",
      password: "",
      passwordFieldType: "password",
      url: this.$apiUrl,
    };
  },
  metaInfo: {
    title: "Sign in - Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses",
      },
      {
        name: "description",
        content:
          "Not a member yet? Register with Caregiver Saathi for free and get access to community, informative content, courses and home-care services",
      },
    ],
  },
  mounted() {
    // ****************
    // window.otplessGetDiv();
    // window.otpless = async (otplessUser) => {
    //   const waName = otplessUser.waName;
    //   const waNumber = otplessUser.waNumber;
    //   // console.log("WHATSAPP USERDATA MOUNTED", waName, waNumber);
    //   if (waName && waNumber) {
    //     await this.signUpActionWhatsapp(waName, waNumber);
    //     this.$router.push({ name: "home" });
    //   }
    // };
    // ****************
  },

  methods: {
    async verifyUser(val) {
      let payload;
      if (this.Username.includes("CGX" && "EMP")) {
        payload = {
          eid: this.Username,
        };
      } else if (this.Username.includes("@" && ".")) {
        payload = {
          email: this.Username.toLowerCase().trim(),
        };
      } else {
        payload = {
          mobile: this.Username,
        };
      }
      try {
        const getUser = await this.$store.dispatch("auth/getUser", payload);
      } catch (error) {
        console.log(error);
        if (error.response.status) {
          this.$swal
            .fire({
              title: "Error",
              text: error.response.data.message,
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            })
            .then((result) => {
              if (error.response.data.message == "Please set password!") {
                this.$router.push({
                  name: "forgot-password",
                  query: { setPassword: true },
                });
              }
              if (
                error.response.data.message.includes(
                  "Your account is in-active"
                )
              ) {
                this.$router.push({ name: "account-active" });
                console.log("Move to activate account page");
              }
            });
        }
      }
    },
    handleUsername(val) {
      if (this.Username.includes("@" && "."))
        this.Username = this.Username.toLowerCase();
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    async onSubmit() {
      var payload = {};
      let reg = /[a-zA-Z]/g;
      let result = this.Username.search(reg);
      if (this.Username.includes("CGX" && "EMP")) {
        var payload = {
          eid: this.Username,
          password: this.password,
          selectedRole: "volunteer",
        };
      } else if (this.Username.includes("@" && ".")) {
        var payload = {
          email: this.Username.toLowerCase(),
          password: this.password,
          selectedRole: "volunteer",
        };
      } else if (result >= 0) {
        this.$swal.fire({
          title: "Invalid Email",

          text: "Please enter your correct Email-id",

          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.password = null;
        this.Username = null;
      } else {
        var payload = {
          mobile: this.Username,
          password: this.password,
          selectedRole: "volunteer",
        };
      }

      let loader = this.$loading();
      try {
        if (this.Username != null && this.password != null) {
          const { data } = await this.$store.dispatch(
            "auth/loginWithPassword",
            payload
          );
          if (!data.user.role || !data.user.role.includes("volunteer")) {
            loader.close();
            this.$swal.fire({
              title: "Access Denied",
              text: "Only volunteer users are allowed to sign in here.",
              icon: "error",
              confirmButtonColor: "#830c81",
            });
            return;
          }

          // this.$router.push({ name: "home" });
          if (window.localStorage.getItem("forgotPassword")) {
            this.$router.push({ name: "home" });
            window.localStorage.removeItem("forgotPassword");
          } else {
            if (window.localStorage.getItem("last-redirection") == "register") {
              this.$router.push({ name: "home" });
              window.localStorage.removeItem("last-redirection");
            } else {
              const lastPage = localStorage.getItem("lastPageBeforeLogin");
              if (lastPage) {
                localStorage.removeItem("lastPageBeforeLogin");
                this.$nextTick(() => {
                  this.$router.replace(lastPage);
                });
              } else {
                this.$router.push({ name: "home" });
                // this.$router.go(-1);
              }
            }
          }
          this.$store.commit("auth/userData", data.user);
          localStorage.setItem("userToken", data.token);

          if (data.user.defaultPassword == true) {
            this.$swal
              .fire({
                title: "Logging In for first time",
                // text: "Please change the password",
                html: "<p style='text-align:center'>Please change the password</p>",
                icon: "warning",
                confirmButtonColor: "#830c81",
                showCancelButton: false,
              })
              .then((result) => {
                if (result.value) {
                  this.$router.push({
                    name: "forgot-password",
                    query: { change: "true" },
                  });
                }
              });
          } else {
            this.$router.push({ name: "home" });
          }
          const data1 = await this.$store.dispatch("eLearning/getProfile", {
            userId: data.user._id,
          });
          if (data.user.role == "volunteer") {
            const data2 = await this.$store.dispatch(
              "respitecare/get_volunteerbyuserid",
              {
                volunteerId: data.user._id,
              }
            );
          }
        }
        loader.close();

        // if(data.isPasswordChanged == 0)
        // {
        // this.$router.push({ name: "forgot-password" });
        // }
        // else{
        //   this.$router.push({ name: "home" });
        // }
      } catch (error) {
        loader.close();
        console.log(error);
        this.$refs.formValidator.setErrors({
          Invalid: [error.response.data.message],
        });
        if (error.response.status) {
          this.$swal
            .fire({
              // title: "Error",
              title: "Error",

              text: error.response.data.message,

              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            })
            .then((result) => {
              if (error.response.data.message == "Please set password!") {
                this.$router.push({ name: "forgot-password" });
              }
              if (
                error.response.data.message.includes(
                  "Your account is in-active"
                )
              ) {
                this.$router.push({ name: "account-active" });
                console.log("Move to activate account page");
              }
            });
        }
      }
    },
    register() {
      this.$router.push({ name: "register" });
    },
    async signUpActionWhatsapp(firstName, mobile) {
      try {
        // let userInfo = await this.$store.dispatch("whatsapp/getUserInfo", {
        //   waId: waId,
        // });
        // console.log("WHATSAPP USERINFO:", userInfo);
        let payload = {
          firstname: firstName,
          mobile: mobile,
        };
        const { data } = await this.$store.dispatch(
          "auth/signUpWithWhatsapp",
          payload
        );
        // console.log("WHATSAPP DATA:", data);
        if (data) {
          // console.log("INSIDE DATA");
          this.$store.commit("auth/userData", data.user);
          const data1 = await this.$store.dispatch("eLearning/getProfile", {
            userId: data.user._id,
          });
          if (data.user.role == "volunteer") {
            const data2 = await this.$store.dispatch(
              "respitecare/get_volunteerbyuserid",
              {
                volunteerId: data.user._id,
              }
            );
          }
        }
        if (data.register === true) {
          // this.handleClose();
          this.$swal.fire({
            title: "Registered Successfully",
            html: "<p style='text-align:center'>Discover more features! Check out our plans to find the best fit for you</p>",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status) {
          this.$swal.fire({
            // title: "Error",
            text: error.response.data.message,
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
            showCloseButton: true,
          });
        }
      }
    },

    async getAuthUrl() {
      try {
        this.$store.commit("auth/signinWith", "google");
        this.$store.commit("auth/loginAction", "login");
        let res = await this.$store.dispatch("google/getAuthUrl", {
          redirectURL: this.$homeAuth,
          scopes: ["profile", "email"],
        });
        window.open(res.data, "_self");
      } catch (error) {
        console.log(error);
        await this.errorPop();
      }
    },
    async signUpLinkedIn() {
      this.$store.commit("auth/signinWith", "linkedin");
    },
    async errorPop() {
      return this.$swal({
        text: "Something went wrong. Please try again!!",
        icon: "warning",
        confirmButtonText: "Ok",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        showCloseButton: true,
      });
    },
  },
};
</script>
<style lang="scss">
.p-0card > .card-body {
  padding: 0px !important;
}

.root > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.root > div > .nav-tabs .nav-link {
  width: 220px;
  display: flex;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
    height: 60px;
  }
}
.root-il > div > .nav-tabs .nav-link {
  width: 120px;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
  }
}
/* Oveerflow */
.cust-of > div > .nav {
  overflow-x: auto !important;
}
.cust-of > div > .nav::-webkit-scrollbar {
  width: 8px !important;
  height: 12px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6 !important;
}

.cust-of > div > .nav::-webkit-scrollbar-thumb {
  background: #d6d6d6 !important;
  border-radius: 6px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px #80808026 !important;
  border-radius: 6px !important;
}
.scope-padding > .card-body {
  padding-left: 0%;
  padding-right: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}

.root-il > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root-il > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root-il > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root-il > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root-il > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.form-group {
  margin-bottom: 3px;
}
.h-360px {
  height: 360px;
}
.bg-0060fe {
  background-color: #0060fe;
}
.border-4f0a4b {
  border: 0.5px solid gray;
}
.width15 {
  width: 15.5rem !important;
}
.btn-linkedin {
  background: #0a66c2;
  color: white;
}
.w-240px {
  width: 240px !important;
}
@media (max-width: 640px) {
  .custjustifycenter {
    justify-content: center;
  }
}
</style>
